<template>
  <v-form v-model="valid" ref="form" v-bind="this.$attrs" class="mb-6">
    <v-row>
      <v-col cols="12" md="6">
        <AutocompleteClass
          v-model="classData"
          return-object
          label="Lớp"
          outlined
          dense
          :rules="[$rules.required]"
          :changeClass="changeClass"
          :currentClass="student && student.currentClass"
          :filter="type"
          hide-details="auto"
          class="required"
          @change="onClassChange"
        />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import AutocompleteClass from '@/components/basic/input/AutocompleteClass'
export default {
  components: {
    AutocompleteClass,
  },
  props: {
    student: {
      type: [Object],
      default: () => {},
    },
  },
  data: () => ({
    valid: true,
    classData: null,
    changeClass: false,
  }),
  computed: {
    type() {
      return { type: 'coreCurriculum' }
    },
  },
  created() {
    if (this.student) {
      this.classData = this.student.currentClass
    }
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    reset() {
      this.$refs.form.reset()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    getData() {
      if (typeof this.classData !== 'object') return
      return {
        classObject: this.classData,
        class: this.classData.id,
        grade: this.classData.grade.id,
      }
    },
    onClassChange() {
      this.changeClass = true
    },
  },
  watch: {
    student(student) {
      this.classData = student.currentClass
    },
  },
}
</script>

<style scoped></style>
